export function flashMessage(type, message, icon) {
  const t = `
        <div class="flash-message ${type}">
            <div class="container">
                <div class="message"><span class="fas fa-${icon}"></span>&nbsp;&nbsp;&nbsp;${message}</div>
            </div>
            <a href="#" class="close-btn">
                <span class="fas fa-times"></span>
            </a>
        </div>
    `;
  const template = document.createElement("template");
  template.innerHTML = t.trim();
  const m = template.content.firstChild;
  template.remove();
  m.querySelector(".close-btn").addEventListener("click", function (e) {
    e.preventDefault();
    m.remove();
  });
  setTimeout(() => {
    m.remove();
  }, 10000);
  document.body.appendChild(m);
}

export function flashSuccess(message) {
  flashMessage("success", message, "check");
}

export function flashError(message) {
  flashMessage("error", message, "bug");
}

const proxy = (type, message, icon) => {
  return new Proxy(
    { message },
    {
      set(target, property, value, receiver) {
        flashMessage(type, value, icon);
        return Reflect.set(...arguments);
      },
    }
  );
};

window.flashSuccess = proxy("success", null, "check");
window.flashError = proxy("error", null, "bug");
